export const SearchSubmitButton = ({ onClick }: any) => {
  return (
    <button type='submit' className='btn btn-primary' onClick={onClick}>
      <i className='ri-search-line align-bottom me-1'></i> Search
    </button>
  );
};
